import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../components/loader';
import * as loaderAction from '../actions/loaderAction';

function mapStateToProps(state) {
  return state.Loader;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...loaderAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
